import { render, staticRenderFns } from "./ListFakeTeams.vue?vue&type=template&id=0d406003&scoped=true"
import script from "./ListFakeTeams.vue?vue&type=script&lang=js"
export * from "./ListFakeTeams.vue?vue&type=script&lang=js"
import style0 from "./ListFakeTeams.vue?vue&type=style&index=0&id=0d406003&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d406003",
  null
  
)

export default component.exports